(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ppv-sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ppv-sticky-atc')) {
    customElements.define('ppv-sticky-atc', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.data = JSON.parse(this.querySelector('[data-ppv-data]').textContent);
        this.variants = new Map(this.data.variants.map(variant => [String(variant.id), variant]));
        this.strings = this.data.strings;
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: this.dataset.currency });
        this.desktop = matchMedia('(min-width: 720px)');
        this.bar = this.querySelector('.ppv-satc__bar');
        this.dialog = this.querySelector('dialog');
        this.addButton = this.querySelector('[data-ppv-add]');
        this.addLabel = this.querySelector('[data-ppv-add-label]');
        this.errorBox = this.querySelector('[data-ppv-error]');
        this.clearance = document.createElement('div');
        this.clearance.className = 'ppv-satc__clearance';
        this.clearance.setAttribute('aria-hidden', 'true');
        document.body.appendChild(this.clearance);
        const signal = this.controller.signal;
        this.addEventListener('click', event => this.onClick(event), { signal });
        this.dialog.addEventListener('close', () => {
          this.querySelectorAll('[data-ppv-open-size]').forEach(button => button.setAttribute('aria-expanded', 'false'));
          this.schedule();
        }, { signal });
        this.dialog.addEventListener('click', event => {
          const bounds = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientY < bounds.top || event.clientX < bounds.left || event.clientX > bounds.right)) this.dialog.close();
        }, { signal });
        window.addEventListener('scroll', () => this.schedule(), { passive: true, signal });
        window.addEventListener('resize', () => this.schedule(), { passive: true, signal });
        window.addEventListener('pageshow', () => this.bindSource(), { signal });
        window.visualViewport?.addEventListener('resize', () => this.schedule(), { passive: true, signal });
        document.addEventListener('shopify:section:load', () => this.bindSource(), { signal });
        document.addEventListener('product-info:loaded', () => this.bindSource(), { signal });
        document.addEventListener('focusin', () => this.schedule(), { signal });
        this.desktop.addEventListener('change', () => { if (this.dialog.open) this.dialog.close(); this.schedule(); }, { signal });
        this.layoutObserver = new ResizeObserver(() => this.schedule());
        this.layoutObserver.observe(this.bar);
        this.overlayObserver = new MutationObserver(mutations => {
          if (mutations.some(mutation => {
            const target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
            if (this.contains(target) || target === this.clearance) return false;
            if (target === document.body || target?.closest('cart-drawer,cart-notification,product-modal,modal-dialog,dialog,.section-header,header,.shopify-pc__banner,[role="dialog"],[role="alertdialog"],[id^="trustbadge-container"]')) return true;
            return [...mutation.addedNodes, ...mutation.removedNodes].some(node => node.nodeType === 1 && node.matches?.('cart-drawer,dialog,[id^="shopify-pc"],[id^="trustbadge-container"],iframe#preview-bar-iframe'));
          })) this.schedule();
        });
        this.overlayObserver.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'open', 'hidden', 'aria-hidden', 'style'] });
        Promise.all([customElements.whenDefined('product-info'), customElements.whenDefined('product-form')]).then(() => {
          if (this.isConnected && this.controller) this.bindSource();
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.setVisibility(false);
        this.sourceController?.abort();
        this.sourceObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.layoutObserver?.disconnect();
        this.overlayObserver?.disconnect();
        this.unsubscribers?.forEach(unsubscribe => unsubscribe());
        cancelAnimationFrame(this.frame);
        clearTimeout(this.variantTimeout);
        clearTimeout(this.submissionTimeout);
        this.restoreBadge();
        this.clearance?.remove();
        if (this.dialog?.open) this.dialog.close();
      }

      bindSource() {
        const source = Array.from(document.querySelectorAll('product-info[id^="MainProduct-"]')).find(element => element.dataset.productId === this.dataset.productId);
        if (!source) { this.setVisibility(false); return; }
        const form = document.getElementById(`product-form-${source.dataset.section}`);
        const submit = form?.querySelector('button[type="submit"]');
        if (!form || !submit || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') { this.setVisibility(false); return; }
        if (this.source === source && this.form === form && this.mainButton === submit) { this.sync(); return; }
        this.sourceController?.abort();
        this.sourceObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.unsubscribers?.forEach(unsubscribe => unsubscribe());
        this.sourceController = new AbortController();
        this.source = source;
        this.form = form;
        this.mainButton = submit;
        this.sectionId = source.dataset.section;
        this.unsubscribers = [
          subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, payload => {
            if (!this.source.contains(payload.data?.event?.target)) return;
            this.variantPending = true;
            this.showError('');
            clearTimeout(this.variantTimeout);
            this.variantTimeout = setTimeout(() => {
              if (!this.variantPending) return;
              this.variantPending = false;
              this.variantFailed = true;
              this.showError(this.strings.variantError);
              this.sync();
            }, 15000);
            this.sync();
          }),
          subscribe(PUB_SUB_EVENTS.variantChange, payload => {
            if (payload.data?.sectionId !== this.sectionId) return;
            this.variantPending = false;
            this.variantFailed = false;
            clearTimeout(this.variantTimeout);
            if (payload.data.variant) this.variants.set(String(payload.data.variant.id), payload.data.variant);
            this.sync();
          }),
          subscribe(PUB_SUB_EVENTS.cartUpdate, payload => {
            if (!this.ownedSubmission || payload.source !== 'product-form' || String(payload.productVariantId) !== this.submittedVariant) return;
            this.submissionResult = 'success';
            this.showError('');
          }),
          subscribe(PUB_SUB_EVENTS.cartError, payload => {
            if (!this.ownedSubmission || String(payload.productVariantId) !== this.submittedVariant) return;
            this.submissionResult = 'error';
            this.showError(typeof payload.errors === 'string' ? payload.errors : payload.message || this.strings.networkError);
          })
        ];
        this.sourceObserver = new MutationObserver(() => { this.sync(); });
        this.sourceObserver.observe(source, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class', 'value', 'hidden'] });
        this.visibilityObserver = new IntersectionObserver(() => this.schedule(), { threshold: [0, 1] });
        this.visibilityObserver.observe(submit);
        this.layoutObserver.observe(source);
        const header = document.querySelector('.section-header');
        if (header) this.layoutObserver.observe(header);
        this.form.addEventListener('submit', () => {
          this.submissionSeen = true;
          queueMicrotask(() => this.sync());
        }, { signal: this.sourceController.signal });
        this.sync();
      }

      formatMoney(cents) { return this.money.format(Number(cents) / 100); }

      formatUnit(variant) {
        const measurement = variant?.unit_price_measurement;
        const saved = this.data.unitPrices?.[String(variant?.id)];
        const price = variant?.unit_price ?? saved?.price;
        const reference = measurement?.reference_unit || saved?.unit;
        const amount = measurement?.reference_value || saved?.amount || 1;
        if (price == null || !reference) return '';
        return `${this.formatMoney(price)}/${Number(amount) !== 1 ? amount : ''}${reference.toLowerCase()}`;
      }

      sync() {
        if (!this.source?.isConnected || !this.form?.isConnected || !this.mainButton?.isConnected) { this.setVisibility(false); return; }
        const input = this.form.querySelector('[name="id"]');
        const selectedJson = this.source.querySelector('variant-selects [data-selected-variant]');
        if (selectedJson) {
          try {
            const nativeVariant = JSON.parse(selectedJson.textContent);
            if (nativeVariant) this.variants.set(String(nativeVariant.id), nativeVariant);
          } catch (error) { this.variantFailed = true; }
        }
        const current = this.variants.get(String(input?.value || this.dataset.defaultVariant));
        this.current = current;
        const nativeLoading = this.mainButton.classList.contains('loading');
        if (this.ownedSubmission && this.submissionSeen && !nativeLoading) {
          this.ownedSubmission = false;
          clearTimeout(this.submissionTimeout);
          if (!this.submissionResult) this.showError(this.strings.networkError);
        }
        if (this.variantPending && !input?.value && !nativeLoading) {
          this.variantPending = false;
          clearTimeout(this.variantTimeout);
        }
        if (current) {
          this.querySelector('[data-ppv-price]').textContent = this.formatMoney(current.price);
          const compare = this.querySelector('[data-ppv-compare]');
          compare.hidden = !(current.compare_at_price > current.price);
          compare.textContent = compare.hidden ? '' : this.formatMoney(current.compare_at_price);
          const unit = this.formatUnit(current);
          this.querySelector('[data-ppv-unit]').textContent = unit;
          this.querySelector('[data-ppv-unit-separator]').hidden = !unit;
          this.querySelectorAll('[data-ppv-selected-size]').forEach(element => { element.textContent = current.title.replace(/\s*ml\b/gi, ' ml'); });
          this.querySelectorAll('[data-ppv-variant]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ppvVariant === String(current.id))));
        }
        this.variants.forEach(variant => {
          const price = this.querySelector(`[data-ppv-option-price="${variant.id}"]`);
          const unit = this.querySelector(`[data-ppv-option-unit="${variant.id}"]`);
          const stock = this.querySelector(`[data-ppv-option-stock="${variant.id}"]`);
          if (price) price.textContent = this.formatMoney(variant.price);
          if (unit) unit.textContent = this.formatUnit(variant);
          if (stock) stock.hidden = variant.available;
        });
        const busy = this.variantPending || nativeLoading || this.ownedSubmission;
        const invalid = !input?.value || !current;
        const soldOut = !invalid && !current.available;
        this.addButton.disabled = !!busy || soldOut || (!invalid && this.mainButton.disabled && !this.variantFailed);
        this.addButton.setAttribute('aria-busy', String(!!busy));
        this.querySelector('.ppv-satc__spinner').hidden = !busy;
        this.addLabel.textContent = this.variantPending ? this.strings.updating : nativeLoading || this.ownedSubmission ? this.strings.adding : invalid || this.variantFailed ? this.strings.choose : soldOut ? this.strings.soldOut : this.strings.add;
        this.schedule();
      }

      onClick(event) {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-ppv-details')) {
          const description = this.source.querySelector('.product__description');
          if (description) this.scrollToElement(description);
          return;
        }
        if (button.hasAttribute('data-ppv-close-size')) { this.dialog.close(); return; }
        if (button.hasAttribute('data-ppv-open-size')) {
          if (this.dataset.directVariants !== 'true') { this.goToOptions(); return; }
          button.setAttribute('aria-expanded', 'true');
          this.dialog.showModal();
          return;
        }
        if (button.dataset.ppvVariant) { this.selectVariant(button.dataset.ppvVariant, button); return; }
        if (button.hasAttribute('data-ppv-add')) this.addToCart();
      }

      selectVariant(id, clickedButton) {
        const variant = this.variants.get(String(id));
        if (!variant || this.ownedSubmission || this.mainButton.classList.contains('loading')) return;
        if (this.current && String(this.current.id) === String(id) && !this.variantFailed) { if (this.dialog.open) this.dialog.close(); return; }
        const picker = this.source.querySelector('variant-selects');
        if (!picker || typeof publish !== 'function') { this.goToOptions(); return; }
        const groups = Array.from(picker.querySelectorAll('.product-form__input'));
        const choices = variant.options.map((value, index) => {
          const group = groups[index];
          if (!group) return null;
          const select = group.querySelector('select');
          if (select) return { select, option: Array.from(select.options).find(option => option.value === value) };
          return { input: Array.from(group.querySelectorAll('input[type="radio"]')).find(input => input.value === value) };
        });
        if (choices.some(choice => !choice || (!choice.input && !choice.option))) { this.goToOptions(); return; }
        let target;
        choices.forEach(choice => {
          if (choice.select) {
            choice.select.value = choice.option.value;
            Array.from(choice.select.options).forEach(option => option.toggleAttribute('selected', option === choice.option));
            target = choice.option;
          } else {
            choice.input.checked = true;
            target = choice.input;
          }
        });
        const focusTarget = this.dialog.open ? this.querySelector('.ppv-satc__size--mobile') : clickedButton;
        if (this.dialog.open) this.dialog.close();
        if (!focusTarget.id) focusTarget.id = `PPVStickyFocus-${this.dataset.productId}`;
        this.variantFailed = false;
        publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event: { target },
            target: { id: focusTarget.id, dataset: target.dataset },
            selectedOptionValues: picker.selectedOptionValues
          }
        });
      }

      addToCart() {
        if (this.addButton.disabled || this.ownedSubmission || this.variantPending) return;
        if (!this.current || this.variantFailed || !this.form.querySelector('[name="id"]')?.value) { this.goToOptions(); return; }
        if (this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true') return;
        if (!this.form.checkValidity()) {
          this.scrollToElement(this.form.querySelector(':invalid') || this.form);
          this.form.reportValidity();
          return;
        }
        this.showError('');
        this.ownedSubmission = true;
        this.submissionResult = null;
        this.submissionSeen = false;
        this.submittedVariant = String(this.current.id);
        this.sync();
        this.form.requestSubmit(this.mainButton);
        this.submissionTimeout = setTimeout(() => {
          if (this.ownedSubmission) this.showError(this.strings.networkError);
        }, 20000);
      }

      showError(message) {
        this.errorBox.textContent = message;
        this.errorBox.hidden = !message;
        this.schedule();
      }

      goToOptions() {
        if (this.dialog.open) this.dialog.close();
        const picker = this.source.querySelector('variant-selects') || this.form;
        this.scrollToElement(picker);
        picker.querySelector('input:not([type="hidden"]),select,button')?.focus({ preventScroll: true });
      }

      scrollToElement(element) {
        const targetTop = element.getBoundingClientRect().top;
        const belowButton = this.mainButton && targetTop > this.mainButton.getBoundingClientRect().bottom;
        const offset = belowButton ? 0 : this.headerHeight();
        const top = targetTop + window.scrollY - offset - 16;
        window.scrollTo({ top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }

      headerHeight() {
        const header = document.querySelector('.section-header');
        if (!header || !header.classList.contains('shopify-section-header-sticky') || header.classList.contains('shopify-section-header-hidden')) return 0;
        return Math.max(0, header.getBoundingClientRect().bottom);
      }

      elementVisible(element) {
        if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
        const style = getComputedStyle(element);
        return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0 && element.getBoundingClientRect().height > 0;
      }

      blockedByOverlay() {
        if (this.dialog.open) return false;
        if (document.querySelector('cart-drawer.active,cart-notification.active,product-modal[open],modal-dialog[open],header details[open]')) return true;
        if (document.body.classList.contains('overflow-hidden') || (!this.desktop.matches && document.body.classList.contains('overflow-hidden-tablet'))) return true;
        return Array.from(document.querySelectorAll('#shopify-pc__banner,#shopify-pc__prefs,dialog[open],[role="dialog"][aria-modal="true"],[role="alertdialog"]')).some(element => !this.contains(element) && this.elementVisible(element));
      }

      schedule() {
        if (!this.controller || this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.updatePosition(); });
      }

      setVisibility(visible) {
        if (this.hidden === visible) this.hidden = !visible;
        if (document.body.classList.contains('ppv-sticky-atc-visible') !== visible) {
          document.body.classList.toggle('ppv-sticky-atc-visible', visible);
        }
        if (!visible) {
          if (this.clearance?.style.height !== '0px') this.clearance?.style.setProperty('height', '0px');
          this.restoreBadge();
        }
      }

      updatePosition() {
        if (!this.source?.isConnected || !this.form?.isConnected || !this.mainButton?.isConnected) { this.setVisibility(false); return; }
        const header = this.headerHeight();
        const preview = document.getElementById('preview-bar-iframe');
        const previewHeight = preview && this.elementVisible(preview) ? Math.max(0, window.innerHeight - preview.getBoundingClientRect().top) : 0;
        this.style.setProperty('--ppv-satc-top', '0px');
        this.style.setProperty('--ppv-satc-preview', `${previewHeight}px`);
        const editable = document.activeElement?.matches('input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]),textarea,[contenteditable="true"]');
        const keyboard = editable && window.visualViewport && window.visualViewport.height < window.innerHeight * .75;
        const passedButton = this.mainButton.getBoundingClientRect().bottom <= header + 2;
        const visible = this.dialog.open || (passedButton && !this.blockedByOverlay() && !keyboard);
        this.setVisibility(visible);
        const height = visible ? Math.ceil(this.bar.getBoundingClientRect().height) : 0;
        const clearance = visible ? height : 0;
        if (this.clearance.style.height !== `${clearance}px`) this.clearance.style.height = `${clearance}px`;
        if (visible) this.liftBadge(height + previewHeight); else this.restoreBadge();
      }

      liftBadge(height) {
        if (!this.badge?.element.isConnected) {
          const container = document.querySelector('[id^="trustbadge-container-"]');
          const element = container && Array.from(container.querySelectorAll('*')).find(node => {
            const bounds = node.getBoundingClientRect();
            return getComputedStyle(node).position === 'fixed' && bounds.width > 0 && bounds.width < 220 && bounds.height > 0 && bounds.height < 160 && getComputedStyle(node).bottom !== 'auto';
          });
          if (!element) return;
          this.badge = { element, value: element.style.getPropertyValue('bottom'), priority: element.style.getPropertyPriority('bottom'), baseline: parseFloat(getComputedStyle(element).bottom) || 0 };
        }
        const bottom = `${Math.max(this.badge.baseline, height + 12)}px`;
        if (this.badge.element.style.bottom !== bottom) this.badge.element.style.setProperty('bottom', bottom, 'important');
      }

      restoreBadge() {
        if (!this.badge) return;
        if (this.badge.value) this.badge.element.style.setProperty('bottom', this.badge.value, this.badge.priority);
        else this.badge.element.style.removeProperty('bottom');
        this.badge = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
